<template>
  <q-dialog v-model="confirmDialog.isVisible.value" persistent>
    <q-card :style="cardStyle">
      <q-card-section>
        <div class="text-h6">{{ confirmDialog.dialogOptions.value.title }}</div>
      </q-card-section>
      <q-card-section>
        <div
          v-if="confirmDialog.dialogOptions.value.html"
          v-html="confirmDialog.dialogOptions.value.message"
        ></div>
        <div v-else class="whitespace-pre-line">
          {{ confirmDialog.dialogOptions.value.message }}
        </div>
      </q-card-section>
      <q-card-actions align="right">
        <dtpBtn
          v-if="confirmDialog.dialogOptions.value.cancel !== false"
          flat
          :label="cancelLabel"
          color="secondary"
          @click="confirmDialog.cancel()"
        />
        <dtpBtn
          flat
          :label="okLabel"
          color="primary"
          @click="confirmDialog.confirm()"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { confirmDialog } from "@/composables/useConfirmDialog";

const okLabel = computed(() =>
  typeof confirmDialog.dialogOptions.value.ok === "string"
    ? confirmDialog.dialogOptions.value.ok
    : "OK",
);

const cancelLabel = computed(() =>
  typeof confirmDialog.dialogOptions.value.cancel === "string"
    ? confirmDialog.dialogOptions.value.cancel
    : "Cancel",
);

const cardStyle = computed(() => {
  const width = confirmDialog.dialogOptions.value.width;
  // A fixed width is needed to actually constrain the card: with only a
  // min-width the long text expands the card to its max-width regardless.
  return width ? `width: ${width}; max-width: 90vw` : "min-width: 350px";
});
</script>

<style scoped>
:deep(ul) {
  list-style-type: disc;
  padding-left: 20px;
}

:deep(img) {
  display: inline;
}
</style>
